// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import { times } from 'lodash';

import { SimilarListingsFields } from '@reverbdotcom/commons/src/gql/graphql';

import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { OverflowingRow } from '@reverbdotcom/commons';
import { AddToCartButtonFragment } from '@reverbdotcom/commons/src/components/add_to_cart_button';
import ListingCard, { ListingCardFragment } from '@reverbdotcom/commons/src/components/listing_card';
import { useURL } from '@reverbdotcom/commons/src/url_context';
import { isReferredFromGoogle } from '@reverbdotcom/commons/src/url_helpers';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { MParticleEvent } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { RCGrid } from '@reverbdotcom/cadence/components';

interface IProps {
  similarListings: SimilarListingsFields.Fragment[];
  title?: string;
  showFlags: boolean;
  experiments?: string[];
  displayAddToCart?: boolean;
}

const COMPONENT_NAME = 'SimilarListings';
const PLACEHOLDER_ITEM_COUNT = 5;

function renderGridPlaceholders() {
  return times(PLACEHOLDER_ITEM_COUNT, index => (
    <RCGrid.Item
      colSpan={{ desktop: 2, tablet: 3, mobile: 5 }}
      key={index}
    >
      <ListingCard />
    </RCGrid.Item>
  ));
}

export function SimilarListingsRow({
  similarListings,
  showFlags = false,
  experiments = undefined,
  displayAddToCart = false,
  title = I18n.t('discovery.listingsRow.similarListings'),
}: IProps) {
  const user = useUser();

  const event: MParticleEvent = {
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
    similarListingsCount: similarListings?.length || 0,
  };

  if (experiments) {
    event.experiments = formatExperimentsForEventAttributes(user, experiments);
  }

  useViewTracking(event, true);

  const shouldRender = !!similarListings?.length;

  const shouldDisplayAddToCart = isReferredFromGoogle(useURL()) || !!displayAddToCart;

  if (!shouldRender) { return null; }

  const loading = !similarListings;

  return (
    <div className="similar-listings-row">
      <OverflowingRow
        title={title}
      >
        <RCGrid
          singleRowOn="all"
          disableAndPulse={loading}
        >
          {loading && similarListings.length === 0 ? (
            renderGridPlaceholders()
          ) : (
            similarListings.map((listing, idx) => (
              <RCGrid.Item
                colSpan={{ desktop: 2, tablet: 3, mobile: 5 }}
                key={listing.id}
              >
                <ListingCard
                  key={listing.id}
                  listing={listing}
                  position={idx}
                  displayAddToCart={shouldDisplayAddToCart}
                  trackingName={COMPONENT_NAME}
                  showFlag={showFlags}
                />
              </RCGrid.Item>
            ))
          )}
        </RCGrid>
      </OverflowingRow>
    </div>
  );
}

export const SimilarListingsFragment = gql`
  fragment SimilarListingsFields on Listing {
    _id
    id
    ...ListingCardFields
    ...AddToCartButtonFields
  }
  ${ListingCardFragment}
  ${AddToCartButtonFragment}
`;

export default SimilarListingsRow;
